// extracted by mini-css-extract-plugin
export default {"shell":"PageShell_shell__qh-VB","wordmark":"PageShell_wordmark__uakBk","note":"PageShell_note__IIXWH","stack":"PageShell_stack__uuaUh"};